import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import Card from "components/Card";
import Page from "components/Page";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import styles from "./EventDetails.module.scss";
import editIcon from "assets/images/edit-icon.svg";
import deleteIcon from "assets/images/delete-icon.svg";
import historyLogsIcon from "assets/images/document_search.svg";
import duplicateIcon from "assets/images/duplicate.svg";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import DetailsTab from "./components/DetailsTab";
import { Tooltip } from "reactstrap";
import RequestToJoin from "./components/RequestToJoin";
import constants from "../../../constants";
import {
  getEventListDetails,
  acceptRequestEventToJoin,
  rejectRequestEventToJoin,
} from "repositories/scheduler-repository";
import { useParams, Link } from "react-router-dom";
import Loader from "components/Loader";
import SpecficDates from "./components/Modals/SpecficDates";
import toast from "react-hot-toast";
import RejectionModal from "./components/Modals/RejectionModal";
import AcceptConfirmation from "./components/Modals/AcceptConfirmation";
import ReasonOfRejection from "./components/Modals/ReasonOfRejection";
import Eventnotexist from "../components/Modal/Eventnotexist";
import { decodeId, encodeId, getStorage } from "utils";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import InvitationRequestModal from "./components/InvitationRequestModal";
import { addEditEventsConst } from "../AddEvent/addEvents.constants";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import { useSimpleEventCardDelete } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventShiftsView/useSimpleEventCardDelete";

/**
 * Resolves fallback navigation target when browser back stack is unavailable.
 */
const getEventDetailsFallbackRoute = ({ state, isChatFromDashBoard }) => {
  if (state.fromScreen === "staffSchedule") {
    return "/scheduler";
  }
  if (isChatFromDashBoard) {
    return constants.routes.dashboard.managerDashboard;
  }
  if (state?.from === "notifications") {
    return constants.routes.notification.notificationDetail;
  }
  return constants.routes.scheduler.calendar;
};

const EventDetails = ({ t, location, history, match }) => {
  const isChatFromDashBoard = getStorage(
    constants.notes.cache.isChatFromDashBoard,
  );

  const state = location?.state || history?.location?.state || {};
  const [eventDetails, seteventDetails] = useState(null);
  const {
    effectiveOwnerId,
    getIdToCheckOwnerChange,
    effectiveOwnerIdString,
    dataAccessValues,
  } = useAccountOwnerCommon();
  useEffect(() => {
    if (!effectiveOwnerId) return;
    if (getIdToCheckOwnerChange()) {
      goBack();
    }
  }, [effectiveOwnerId]);
  const goBack = () => {
    if (window.history.length > 1) {
      return history.goBack();
    }
    if (state.fromScreen === "schedulingAssistant") {
      if (state.eventId) {
        history.push({
          pathname: constants.routes.scheduler.editEvent.replace(
            ":eventId",
            state.eventId,
          ),
          state: {
            ...state.schedulingAssistantState,
            requestedDate: state.requestedDate,
            setSchedulingAssistantTab: true,
            ownerId: eventDetails?.ownerId,
          },
        });
      } else {
        history.push({
          pathname: "/add-event",
          state: {
            ...state.schedulingAssistantState,
            requestedDate: state.requestedDate,
            setSchedulingAssistantTab: true,
          },
        });
      }
      return;
    }
    history.push(getEventDetailsFallbackRoute({ state, isChatFromDashBoard }));
  };

  const requestedDate =
    eventDetails?.repeatedType ===
    addEditEventsConst.repeatedOptionsValues.never
      ? eventDetails.date
      : state?.requestedDate;

  const profile = useSelector((state) => state.userProfile.profile);
  const isAccountOwner =
    profile && profile?.role
      ? profile.role.systemRole === constants.systemRoles.accountOwner
      : false;
  const isEventOfficeAdmin = Boolean(
    dataAccessValues?.officeList?.some(
      (office) => office.officeId === eventDetails?.officeId && office.isAdmin,
    ),
  );
  const isAdmin = Boolean(
    profile?.isAdmin || dataAccessValues?.isAdmin || isEventOfficeAdmin,
  );
  const isCreator = eventDetails?.createdById === profile?.id;
  const canDuplicate = isAccountOwner || isAdmin || isCreator;

  const [activeTab, setActiveTab] = useState("1");
  let { eventId } = useParams();
  eventId = decodeId(eventId);
  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const [tooltipDeleteOpen, setTooltipDeleteOpen] = useState(false);
  const [tooltipHistoryLogsOpen, setTooltipHistoryLogsOpen] = useState(false);
  const [loaderShow, setloaderShow] = useState(true);
  const [, setSpecficDates] = useState({});
  const [isSelectedRequestedEvent, setIsSelectedRequestedEvent] = useState({});
  const [rejectedTest, SetRejectedTest] = useState();
  const [isError, setIsError] = useState({});
  const [tooltipDuplicateOpen, setTooltipDuplicateOpen] = useState(false);

  const moveToEditPage = () => {
    history.push({
      pathname: constants.routes.scheduler.editEvent.replace(
        ":eventId",
        encodeId(eventId),
      ),
      state: {
        requestedDate,
        eventEmployeesList: eventDetails?.eventEmployees,
        ownerId: eventDetails?.ownerId,
      },
      search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
    });
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    SetRejectedTest("");
    setIsError({});
  }, [isSelectedRequestedEvent]);

  const getDetails = async () => {
    const schedularEventDate = moment(requestedDate).format("YYYY-MM-DD");

    try {
      let response = await getEventListDetails(eventId, schedularEventDate);
      if (response && response?.data) {
        seteventDetails(response?.data);
      }
      setloaderShow(false);
    } catch (error) {
      setloaderShow(false);
    }
  };

  const acceptEvent = async () => {
    if (!isSelectedRequestedEvent?.id) return;
    try {
      let res = await acceptRequestEventToJoin(isSelectedRequestedEvent?.id);
      if (res.statusCode === 200) {
        eventDetails.eventRequestToJoins[
          isSelectedRequestedEvent.index
        ].status = constants.SCHEDULERSTATUS.ACCEPT;
        setIsSelectedRequestedEvent({});
        seteventDetails({ ...eventDetails });
        toast.success(res.message);
      } else if (res.statusCode === 406) {
        setIsSelectedRequestedEvent((prev) => ({
          ...prev,
          type: constants.SCHEDULEREVENTTYPE.inviteStaff,
        }));
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const rejectEvent = async () => {
    if (!rejectedTest?.trim()?.length) {
      isError.reasonForRejection = t("form.errors.reasonOfRejection");
      setIsError({ ...isError });
      return;
    } else {
      delete isError.reasonForRejection;
      setIsError({ ...isError });
    }

    if (
      isSelectedRequestedEvent?.id &&
      rejectedTest?.length <= constants.wordLimits.REJECTOINREQUESTJOIN
    ) {
      try {
        let res = await rejectRequestEventToJoin(
          isSelectedRequestedEvent?.id,
          rejectedTest,
        );
        if (res.statusCode === 200) {
          eventDetails.eventRequestToJoins[
            isSelectedRequestedEvent?.index
          ].status = constants.SCHEDULERSTATUS.REJECT;
          eventDetails.eventRequestToJoins[
            isSelectedRequestedEvent?.index
          ].reasonForRejection = rejectedTest;
          seteventDetails({ ...eventDetails });
          setIsSelectedRequestedEvent({});
          toast.success(res.message);
        }
      } catch (err) {
        toast.error(err.message);
      }
    }
  };

  const eventKey = useMemo(
    () => ({
      eventOrShift: t(
        `accountOwner.${eventDetails?.isShift ? "shift" : "event"}Tab`,
      ),
    }),
    [eventDetails?.isShift],
  );
  const eventKeyLowerCase = useMemo(
    () => ({
      eventOrShift: eventKey.eventOrShift.toLowerCase(),
    }),
    [eventKey],
  );

  const { handleCardDeleteClick, renderSimpleDeleteConfirmModal } =
    useSimpleEventCardDelete({
      t,
      history,
      effectiveOwnerIdString,
      onSuccess: () => {
        history.push({
          pathname: constants.routes.scheduler.calendar,
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
      },
    });

  /**
   * Details Delete uses the same skip rule as the card three-dot menu:
   * single-day, single-staff (or unassigned) events confirm in-place.
   */
  const handleDeleteClick = useCallback(() => {
    if (!eventDetails?.id) return;
    const deleteDate = moment(requestedDate || eventDetails.date).format(
      "YYYY-MM-DD",
    );
    handleCardDeleteClick(eventDetails, deleteDate, {
      lockSelectedUsers: false,
      selectedUserIdsFromStaffView: [],
    });
  }, [eventDetails, handleCardDeleteClick, requestedDate]);

  const modalOpen = () => {
    if (!isSelectedRequestedEvent?.type) return null;
    const modalByType = {
      [constants.SCHEDULEREVENTTYPE.SPECFICDATES]: (
        <SpecficDates
          setSpecficDates={setIsSelectedRequestedEvent}
          specficTimeList={isSelectedRequestedEvent}
          acceptEvent={acceptEvent}
        />
      ),
      [constants.SCHEDULEREVENTTYPE.REASONOFREJECT]: (
        <ReasonOfRejection
          setIsSelectedRequestedEvent={setIsSelectedRequestedEvent}
          isSelectedRequestedEvent={isSelectedRequestedEvent}
        />
      ),
      [constants.SCHEDULEREVENTTYPE.REJECT]: (
        <RejectionModal
          isRejectionModalOpen={true}
          setIsRejectionModalOpen={setIsSelectedRequestedEvent}
          isSelectedRequestedEvent={isSelectedRequestedEvent}
          rejectEvent={rejectEvent}
          rejectedTest={rejectedTest}
          SetRejectedTest={SetRejectedTest}
          isError={isError}
        />
      ),
      [constants.SCHEDULEREVENTTYPE.ACCEPT]: (
        <AcceptConfirmation
          setIsRejectionModalOpen={setIsSelectedRequestedEvent}
          isSelectedRequestedEvent={isSelectedRequestedEvent}
          acceptEvent={acceptEvent}
        />
      ),
      [constants.SCHEDULEREVENTTYPE.inviteStaff]: (
        <InvitationRequestModal
          isModalOpen={true}
          handleConfirm={() => {
            history.push({
              pathname: constants.routes.accountOwner.addStaff.replace(
                ":id",
                encodeId(eventDetails.officeId),
              ),
              state: {
                otherOfficeDetail: {
                  eventId: isSelectedRequestedEvent?.id,
                  ...isSelectedRequestedEvent.requestedBy,
                },
              },
            });
          }}
          closeModal={() => setIsSelectedRequestedEvent(null)}
        />
      ),
    };
    return modalByType[isSelectedRequestedEvent.type] || null;
  };

  return (
    <Page
      onBack={() => {
        goBack();
      }}
      title={t("accountOwner.eventDetails", eventKey)}
    >
      {loaderShow && <Loader />}
      <Card
        className={styles["event-detail-card"] + " margin30"}
        radius="10px"
        marginBottom="18px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
      >
        {eventDetails ? (
          <Fragment>
            <div
              className={
                "d-flex justify-content-between " + styles["align-items-top"]
              }
            >
              <Text
                size="20px"
                marginBottom="10px"
                weight="500"
                color="#111b45"
                break="break-all"
              >
                {eventDetails?.title}
              </Text>

              <div className={styles["delete-edit-icons"]}>
                {canDuplicate && (
                  <>
                    <img
                      src={duplicateIcon}
                      alt="duplicate"
                      id="TooltipDuplicateBtn"
                      onClick={() => {
                        history.push({
                          pathname:
                            constants.routes.scheduler.duplicateEvent.replace(
                              ":eventId",
                              encodeId(eventId),
                            ),
                          state: {
                            duplicateEvent: true,
                            eventData: eventDetails,
                            requestedDate: requestedDate,
                          },
                          search: effectiveOwnerIdString
                            ? `?${effectiveOwnerIdString}`
                            : "",
                        });
                      }}
                      style={{ cursor: "pointer" }}
                    />
                    <Tooltip
                      isOpen={tooltipDuplicateOpen}
                      placement="top"
                      target="TooltipDuplicateBtn"
                      toggle={() => {
                        setTooltipDuplicateOpen(!tooltipDuplicateOpen);
                      }}
                    >
                      {t("scheduler.duplicateEvent", {
                        eventOrShiftOrLeave: eventKey.eventOrShift,
                      })}
                    </Tooltip>
                  </>
                )}

                {(isAccountOwner || isAdmin) && (
                  <>
                    <Link
                      to={{
                        pathname:
                          constants.routes.scheduler.eventHistoryLogs.replace(
                            ":eventId",
                            encodeId(eventId),
                          ),
                        state: {
                          officeName: eventDetails?.officeName,
                          requestedDate: requestedDate,
                          eventEmployeesList: eventDetails?.eventEmployees,
                          eventRepeatedEndDate: eventDetails?.repeatedEndDate,
                          isShift: eventDetails?.isShift,
                        },
                        search: effectiveOwnerIdString
                          ? `?${effectiveOwnerIdString}`
                          : "",
                      }}
                    >
                      <img
                        src={historyLogsIcon}
                        alt="history_logs"
                        id="TooltipHistoryLogsBtn"
                        className={styles.history_logs_icon}
                      />
                    </Link>
                    <Tooltip
                      isOpen={tooltipHistoryLogsOpen}
                      placement="top"
                      target="TooltipHistoryLogsBtn"
                      toggle={() => {
                        setTooltipHistoryLogsOpen(!tooltipHistoryLogsOpen);
                      }}
                    >
                      {t("scheduler.historyLogs", {
                        eventOrShiftOrLeave: eventKey.eventOrShift,
                      })}
                    </Tooltip>
                  </>
                )}

                <Link
                  to={{
                    pathname: constants.routes.scheduler.deleteEvent.replace(
                      ":eventId",
                      encodeId(eventId),
                    ),
                    state: { requestedDate },
                    search: effectiveOwnerIdString
                      ? `?${effectiveOwnerIdString}`
                      : "",
                  }}
                >
                  <img
                    src={deleteIcon}
                    alt="delete"
                    id="TooltipDeleteBtn"
                    className={styles.history_logs_icon}
                  />
                </Link>
                <Tooltip
                  isOpen={tooltipDeleteOpen}
                  placement="top"
                  target="TooltipDeleteBtn"
                  toggle={() => {
                    setTooltipDeleteOpen(!tooltipDeleteOpen);
                  }}
                >
                  {t("scheduler.deleteEvent", eventKey)}
                </Tooltip>

                <img
                  src={editIcon}
                  alt="edit"
                  id="TooltipEditBtn"
                  onClick={moveToEditPage}
                />
                <Tooltip
                  isOpen={tooltipEditOpen}
                  placement="top"
                  target="TooltipEditBtn"
                  toggle={() => {
                    setTooltipEditOpen(!tooltipEditOpen);
                  }}
                >
                  {t("accountOwner.editEvent", eventKey)}
                </Tooltip>
              </div>
            </div>

            <div className="common-tabs mt-3">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab == "1" ? "active" : ""}
                    onClick={() => setActiveTab("1")}
                  >
                    {t("accountOwner.details")}
                  </NavLink>
                </NavItem>

                {!!eventDetails?.publishAsEvent && (
                  <NavItem>
                    <NavLink
                      className={activeTab == "2" ? "active" : ""}
                      onClick={() => setActiveTab("2")}
                    >
                      {t("accountOwner.requestToJoin")}
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  {!!eventDetails && (
                    <DetailsTab
                      eventDetails={eventDetails}
                      seteventDetails={seteventDetails}
                    />
                  )}
                </TabPane>
                <TabPane tabId="2">
                  <RequestToJoin
                    eventDetails={eventDetails}
                    setSpecficDates={setSpecficDates}
                    acceptEvent={acceptEvent}
                    setIsRejectionModalOpen={setIsSelectedRequestedEvent}
                    location={location}
                    history={history}
                    match={match}
                  />
                </TabPane>
              </TabContent>
            </div>
          </Fragment>
        ) : (
          <Eventnotexist eventShiftKey={eventKeyLowerCase} />
        )}
        {modalOpen()}
        {renderSimpleDeleteConfirmModal()}
      </Card>
    </Page>
  );
};

export default withTranslation()(EventDetails);
